import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import exampleQuoteData from '../../../data/exampleQuoteData.json';
import Sidebar from '../../components/Sidebar';
import { setQuoteDataAction } from '../../reduxstore/actions/quoteActions';

const MakersharksDashboard = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dashboardData = useSelector(
    (state) => state?.authReducer?.user?.dashboard,
  );

  const [currentTab, setCurrentTab] = useState(() => {
    const urlQueryParams = new URLSearchParams(window.location.search);
    return urlQueryParams.get('tab') || 'recent_activity';
  });

  const dashboardTabs = [
    { name: 'Recent Activity', identifier: 'recent_activity' },
    { name: 'Buyers', identifier: 'buyers' },
    { name: 'Suppliers', identifier: 'suppliers' },
  ];

  const DashboardTabs = ({ tabs, currentTab, setCurrentTab }) => (
    <div className="flex mt-5 ml-10 min-w-[200px]">
      {tabs.map((tab) => (
        <button
          key={tab.identifier}
          onClick={() => setCurrentTab(tab.identifier)}
        >
          <div
            className={`inline-flex flex-initial px-4 justify-center rounded-full p-2 mr-4 min-w-[150px] ${
              currentTab === tab.identifier
                ? 'font-bold text-white bg-blue-400'
                : 'text-black bg-netral-100 border-solid border-2 border-netral-200'
            }`}
          >
            {tab.name}
          </div>
        </button>
      ))}
    </div>
  );

  const OrderDetails = ({ item }) => (
    <div
      className={`flex flex-col w-180 mt-5 ml-10 border-solid border-2 border-netral-200 rounded-md ${
        item?.status === 'Bid Requested'
          ? 'hover:cursor-pointer'
          : 'hover:cursor-default'
      }`}
      onClick={() => {
        if (item?.status === 'Bid Requested') {
          dispatch(setQuoteDataAction(exampleQuoteData));
          navigate(`/user/review/${item.source_id}`);
        }
      }}
    >
      <div className="flex flex-row flex-initial justify-center mr-2 ml-2 mt-2 mb-2">
        <div className="flex flex-col w-2/12 mr-10">
          <div className="flex flex-row">
            <div className="px-2">
              <img src={item.source_image} width={50} height={50} alt="Logo" />
            </div>
            <div className="px-2">
              <div>
                {item.source_type === 'order' ? 'Order No' : 'Quote No'}
              </div>
              <div className="font-bold">{item.source_id}</div>
            </div>
          </div>
        </div>
        <div className="flex flex-col w-2/12 mr-10">
          <div> Date </div>
          <div className="font-bold">{item.date}</div>
        </div>
        <div className="flex flex-col w-3/12 mr-10">
          <div> Process </div>
          <div className="font-bold">{item.process}</div>
        </div>
        <div className="flex flex-col w-2/12 mr-10">
          <div> Status </div>
          <div
            className={`font-bold ${
              item.status === 'Bid Requested' ? 'text-violet-600' : 'text-black'
            }`}
          >
            {item.status}
          </div>
        </div>
        <div className="flex flex-col w-3/12">
          <div> Updates </div>
          <div className="font-bold">{item.updates}</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="hidden sm:flex items-start">
      <div className="self-stretch">
        <Sidebar />
      </div>
      <div className="flex flex-col w-9/12">
        <DashboardTabs
          tabs={dashboardTabs}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
        {dashboardData &&
          Object.values(dashboardData[currentTab]).map((item) => (
            <OrderDetails key={item.source_id} item={item} />
          ))}
      </div>
    </div>
  );
};

export default MakersharksDashboard;
